import React from 'react'
import config from '../../config.json'
import { connect } from 'react-redux'
import toJS from '../general/toJS.js';
import PageCinemasContent from '../../components/PageCinemas/PageCinemasContent.jsx'
import { CLI_CINEMA_CLIENT_ID, PROGRAM_CINEMAS } from '../../constants/state';
import getData from '../../functions/getData';
import WrapperPageSimple from '../../components/WrapperPage/present/WrapperPageSimple.jsx';

const mapStateToProps = state => ({
    cinemas: getData(state, PROGRAM_CINEMAS),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID)
})

const PageCinemas = ({cinemas, clientCinemaId}) => (
    <WrapperPageSimple
        pageTitleTransId={config.routes.cinemas.transId
    }>
        <div className="cinemas">
            {cinemas && <PageCinemasContent cinemas={cinemas} clientCinemaId={clientCinemaId}/>}
        </div>
    </WrapperPageSimple>
)

export default connect(mapStateToProps)(toJS(PageCinemas))